import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant53() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас ',
      titleFree: 'бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      guaranteeTitle: '100% Гарантия результата',
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Получить бесплатный макет'
    },
    ua: {
      title1: 'Зробимо сайт для вас ',
      titleFree: 'безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      guaranteeTitle: '100% Гарантія результату',
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Отримати безкоштовний макет'
    },
    en: {
      title1: 'We build your website ',
      titleFree: 'for free.',
      title2: `Maintenance — ${price}/mo.`,
      guaranteeTitle: '100% Result Guarantee',
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Get a free mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-829">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-830">
          {/* Left Column - The Guarantee Box */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-831">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-4 text-4xl md:text-5xl lg:text-[3.5rem] font-black leading-[1.1] tracking-tight text-gray-900" data-id="element-832">
              {content.title1}
              <span className="text-blue-600" data-id="element-833">{content.titleFree}</span>
            </motion.h1>

            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="mb-8 text-2xl md:text-3xl font-bold text-gray-500" data-id="element-834">
              {content.title2}
            </motion.h2>

            {/* Guarantee Box */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2
          }} className="bg-blue-50/50 border border-blue-100 p-6 rounded-2xl mb-10 max-w-lg relative overflow-hidden" data-id="element-835">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-100 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none" data-id="element-836" />

              <div className="flex items-center gap-3 mb-3 relative z-10" data-id="element-837">
                <ShieldCheckIcon className="w-6 h-6 text-blue-600" data-id="element-838" />
                <h3 className="font-bold text-gray-900" data-id="element-839">
                  {content.guaranteeTitle}
                </h3>
              </div>
              <p className="text-gray-700 font-medium leading-relaxed relative z-10" data-id="element-840">
                {content.sub}
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} data-id="element-841">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-2xl px-10 py-5 font-bold text-lg transition-all hover:scale-105 bg-blue-600 text-white shadow-xl shadow-blue-600/20" data-id="element-842">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-843" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-844">
            <div className="relative w-full max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-845">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-846" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-847" />
    </>;
}